/**
 * Skeleton-Zeilen für Tabellen/Karten (UX_KONZEPT.md §4 Punkt 1): Ladezustand
 * in Zielgröße statt leerer Fläche, kein Layout-Sprung nach dem Laden.
 */

export function SkeletonZeilen({ zeilen = 4, spalten = 3 }: { zeilen?: number; spalten?: number }) {
  return (
    <>
      {Array.from({ length: zeilen }).map((_, i) => (
        <tr key={i} className="border-t border-slate-100">
          {Array.from({ length: spalten }).map((__, j) => (
            <td key={j} className="px-4 py-2">
              <div className="h-4 w-full max-w-[12rem] animate-pulse rounded-md bg-slate-100" />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

export function SkeletonKarten({ anzahl = 3 }: { anzahl?: number }) {
  return (
    <>
      {Array.from({ length: anzahl }).map((_, i) => (
        <div key={i} className="rounded-lg border border-slate-200 bg-white p-4">
          <div className="h-3 w-24 animate-pulse rounded-md bg-slate-100" />
          <div className="mt-2 h-5 w-32 animate-pulse rounded-md bg-slate-100" />
        </div>
      ))}
    </>
  )
}
